import {combineReducers} from '@modifi/redux'
import {KeyWindowState} from '@modifi/redux/lib/esm/factories/collection/reducer'
import {FileInfoView, OnboardingTradePartnerView} from '@modifi/onboarding-api-clients'

import collectionReducer from './collection'
import documentsReducer from './documents-collection'

export default combineReducers({
  collection: collectionReducer,
  documents: documentsReducer,
})

export type SellerTradePartnerState = {
  collection: KeyWindowState<OnboardingTradePartnerView>
  documents: KeyWindowState<FileInfoView>
}
